import {FormikProps} from 'formik';
import {ChangeEvent} from 'react';
import LikeInputOutlet from '../../../components/IlikeIputOutlet';
import {ShowFormError} from '../../../utilities/helper/showFormError';
import {IBrandForm} from './BrandFormData';

interface IProps {
  form?: FormikProps<IBrandForm>;
}

const BrandNameInput = ({form}: IProps) => {
  return (
    <section className="my-3">
      <p className="mb-2 color-gray-1 text-md font-medium ">
        نام برند <span className="text-red-500">*</span>
      </p>
      <LikeInputOutlet
        name="title"
        label=""
        value={form?.values?.name || ''}
        placeholder="نام برند را وارد کنید"
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form?.setFieldValue('name', e.target.value);
        }}
      />

      <ShowFormError field="name" form={form} />
    </section>
  );
};

export default BrandNameInput;
